import React from "react";
import { Container, Header, SubHeader, Values, CardContainer } from "./styles";
import PropTypes from "prop-types";
import Card from "./Card";

const GeneralStatistics = ({ title, subtitle, bulletPoints }) => {
	return (
		<Container>
			<Header>{title} </Header>
			{subtitle && <SubHeader>{subtitle}</SubHeader>}
			<Values>
				{bulletPoints.map((item, index) => (
					<CardContainer key={item.title || String(index)}>
						<Card title={item.title} description={item.description} />
					</CardContainer>
				))}
			</Values>
		</Container>
	);
};

GeneralStatistics.defaultProps = {
	title: "",
	subtitle: "",
	bulletPoints: [],
};
GeneralStatistics.propType = {
	title: PropTypes.string,
	subtitle: PropTypes.string,
	bulletPoints: PropTypes.shape({
		title: PropTypes.string,
		description: PropTypes.string,
	}),
};

export default GeneralStatistics;
